import {
  ForgotPassword as ForgotPasswordComponent,
  ForgotPasswordConfirmation,
  MessageContainer,
} from "@asayinc/component-library";
import { Box } from "@mui/material";
import { useForgotPasswordMutation } from "src/store/sso";

interface FormFields {
  email: string;
}

export function ForgotPassword() {
  document.title = "Forgot Password | Say Broker Portal";
  const [forgotPassword, response] = useForgotPasswordMutation();

  const submitForm = (data: FormFields) => {
    forgotPassword({ email: data.email, portalName: "broker_portal" });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <MessageContainer>
        {response.isSuccess ? (
          <ForgotPasswordConfirmation />
        ) : (
          <ForgotPasswordComponent submitForm={submitForm} />
        )}
      </MessageContainer>
    </Box>
  );
}
